import React, { useEffect, useState } from 'react';

export const Home: React.FC = () => {

    // Create a use state for api message
    const [message, setMessage] = useState<string>('Loading...');

    // Production URL had to be HTTPS
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

    useEffect(() => {
        fetch(`${API_URL}/api/hello`)
            .then(response => response.json())
            .then(data => {
                setMessage(data.message);
            })
        .catch(error => {
            console.error('Error fetching API:', error);
            setMessage('Error fetching message');
        });
    }, [API_URL]);
    
    // http://localhost:8000/api/hello

    // Return our htmx
    return(
        <div>
            <h1>Home Page Updated! IT NWORKS</h1>
            <p> This is a react front end with hot-reloading</p>
            <p>{message}</p>
        </div>
    )
} 